<template>
    <div class="modal fade" tabindex="-1" id="ModalNormativa">
        <div class="modal-dialog modal-dialog-centered modal-xl">
            <div class="modal-content border-0">
                <div class="modal-body">
                    <div class="py-4 px-4">
                        <h5 class="title">Envie a sua Normativa.</h5>
                        <h6>
                            Envie sua normativa personalizada para melhorar a precisão de suas consultas de <b>Parecer Técnico</b> (na lei 14.133 e 13.303) e <b>Researchs</b> (Analisadores).
                        </h6>
                        <div class="">
                            <form class="" id="formNormativa">
                                <div class="form-group">
                                    <h6>Selecione o arquivo da sua normativa (formatos aceitos .pdf,.txt e .docx)</h6>
                                    <h6>Formatos não aceitos: imagens, documentos digitalizados, arquivos restritos, links, planilhas e tabelas grandes.</h6>

                                    <ImputUploadS3 :reset="reset" :labelText="'Selecionar Arquivo'" @onSave="setUploadFile" @onDelete="deleteUploadFile" :destino="'Norma'" :maxFileSize="800" :multiple="true" :id="'input_file_normativa'" :whoFiles="'.pdf,.txt,.doc,.docx'"></ImputUploadS3>

                                    <div class="norma-arquivos" v-if="files.length">
                                        <p class="text-muted mb-2">Nome e descrição são opcionais. Cada arquivo guarda os próprios campos; o que ficar vazio permanece vazio.</p>
                                        <div class="norma-arquivo" v-for="item in files" :key="item.hash || item.key">
                                            <div class="norma-arquivo-titulo">{{ item.fileName }}</div>
                                            <div class="mb-2">
                                                <label class="form-label" :for="'nmNorma-' + (item.hash || item.key)">Nome</label>
                                                <input :id="'nmNorma-' + (item.hash || item.key)"
                                                       type="text"
                                                       class="form-control"
                                                       maxlength="150"
                                                       v-model="item.nmNorma"
                                                       placeholder="Nome da normativa" />
                                                <small class="text-muted">{{ (item.nmNorma || '').length }}/150. Vazio, a lista mostra o nome do arquivo.</small>
                                            </div>
                                            <div>
                                                <label class="form-label" :for="'dsNorma-' + (item.hash || item.key)">Descrição</label>
                                                <textarea :id="'dsNorma-' + (item.hash || item.key)"
                                                          class="form-control"
                                                          maxlength="500"
                                                          rows="2"
                                                          v-model="item.dsNorma"
                                                          placeholder="Descrição da normativa"></textarea>
                                                <small class="text-muted">{{ (item.dsNorma || '').length }}/500</small>
                                            </div>
                                        </div>
                                    </div>

                                    <button class="btn btn-primary w-100 mt-5" type="button" @click="enviar">Enviar</button>

                                    <div class="mt-4 d-none" v-if="normativas.length > 0">
                                        <h6>Normativa enviada:</h6>

                                        <div class="box-files flex-wrap mt-3">
                                            <div class="item-files me-2 mb-2 fs-6" v-for="(item, index) in normativas" :key="index">
                                                <a class="me-3" href="javascript:void(0)" @click="download(item.urlArquivo, item.dsNome)">{{item.dsNome}}</a>

                                                <button class="btn btn-outline-danger" @click="removeNormativa(item.idNorma)" type="button">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">
                                                        <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                                                        <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                                                    </svg>
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </form>
                        </div>
                    </div>
                </div><!-- .modal-body -->
                <button class="btn btn-md btn-icon btn-pill btn-white shadow position-absolute top-0 end-0 mt-n3 me-n3" data-bs-dismiss="modal">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                        <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                    </svg><!-- x-lg -->
                </button><!-- modal-close -->
            </div><!-- .modal-content -->
        </div><!-- .modal-dialog -->
    </div><!-- .modal -->
</template>

<script>
    import { urlApi, avisoToast, avisoErro } from '@/config/global'
    import axios from 'axios'
    import Swal from 'sweetalert2'
    import ImputUploadS3 from '@/components/Input_Upload_s3'

    export default {
        name: 'ModalNormativa',
        components: { ImputUploadS3 },
        data: function () {
            return {

                usuario: {
                    senhaAtual: null,
                    dsSenha: null,
                    dsSenhaConfirma: null,
                },

                files: [],
                normativas: [],

                reset: false,
            }
        },
        props: {
            showModal: Boolean,
        },
        computed: {
            liberaSalvar() {
                if (this.usuario.senhaAtual == '' || this.usuario.senhaAtual == null) {
                    return false;
                }

                if (this.usuario.dsSenha == '' || this.usuario.dsSenha == null) {
                    return false;
                }

                if (this.usuario.dsSenhaConfirma == '' || this.usuario.dsSenhaConfirma == null) {
                    return false;
                }

                return true;
            }
        },
        methods: {
            enviar() {
                let $this = this;
                if (!this.files || !this.files.length) {
                    avisoErro("Nenhum arquivo selecionado.");
                    return false;
                }

                for (let i = 0; i < this.files.length; i++) {
                    const nome = (this.files[i].nmNorma || '').trim();
                    const descricao = (this.files[i].dsNorma || '').trim();
                    const arquivo = this.files[i].fileName || 'arquivo';
                    if (nome.length > 150) {
                        avisoErro('O nome de "' + arquivo + '" deve conter até 150 caracteres.');
                        return false;
                    }
                    if (descricao.length > 500) {
                        avisoErro('A descrição de "' + arquivo + '" deve conter até 500 caracteres.');
                        return false;
                    }
                }

                var lstFiles = [];
                for (let i = 0; i < this.files.length; i++) {
                    lstFiles.push({
                        key: this.files[i].key,
                        fileName: this.files[i].fileName,
                        nmNorma: (this.files[i].nmNorma || '').trim(),
                        dsNorma: (this.files[i].dsNorma || '').trim(),
                    })
                }

                axios.post(`${urlApi}/Norma/post`, lstFiles)
                        .then(res => {
                            if (res.data.success) {
                                $this.files = [];
                                $this.reset = !$this.reset;
                                avisoToast("Normativa registrada com sucesso.");
                                $this.load();
                                
                                $this.$store.commit('setReload');
                                $this.close();
                            } else {
                                avisoErro("Não foi possível enviar a normativa.");
                            }
                        })
                        .catch(res => {
                            if (res.response.data) {
                                $this.msgErro = res.response.data.msg + " - " + res.response.data.errors[0];
                                avisoErro(res.response.data.msg + " - " + res.response.data.errors[0]);
                            } else {
                                avisoErro("Não foi possível enviar a normativa.");
                            }
                        });

                return false;

            },

            load() {
                //let $this = this;
                //axios.get(`${urlApi}/Norma/Get`, {})
                //    .then(res => {
                //        if (res.data.success) {
                //            $this.normativas = [];
                //            $this.files = null;
                //            $this.reset = !$this.reset;
                //            for (let i = 0; i < res.data.data.rows.length; i++) {
                //                let item = res.data.data.rows[i];

                //                if (item.nmArquivo == null || item.nmArquivo == "") {
                //                    var nomeArquivo = item.urlArquivo.split('/');
                //                    if (nomeArquivo.length > 0) {
                //                        //item.dsNome = nomeArquivo[nomeArquivo.length - 1].slice(7);
                //                        item.dsNome = nomeArquivo[nomeArquivo.length - 1];
                //                    }
                //                } else {
                //                    item.dsNome = item.nmArquivo;
                //                }

                //                $this.normativas.push(item);
                //            }
                //            $this.$store.commit('setLstNormas', $this.normativas)
                //            $this.close();

                //        } else {
                //            avisoErro("Não foi possível carregar a normativa.");
                //        }
                //    })
                //    .catch(res => {
                //        if (res.data != undefined) {
                //            avisoErro(res.data);
                //        } else {
                //            avisoErro("Não foi possível carregar a normativa.");
                //        }
                //    });
            },

            close() {
                //const myModalAlternative = new window.bootstrap.Modal('#ModalNormativa');
                this.myModalAlternative.hide();
            },

            removeNormativa(idNorma) {
                let $this = this;
                let dados = { idNorma: idNorma };
                Swal.fire({
                    title: 'Tem certeza que deseja remover a normativa?',
                    text: 'Esta operação não poderá ser desfeita.',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Sim',
                    cancelButtonText: 'Não',
                    confirmButtonColor: '#83A431',
                }).then((result) => {
                    if (result.isConfirmed) {
                        $this.remover(dados);
                    }
                })
            },

            remover(dados) {
                let $this = this;
                axios.post(`${urlApi}/Norma/Delete`, dados)
                    .then(res => {
                        if (res.data.success) {
                            avisoToast("Normativa removida com sucesso.");
                            $this.load();
                        } else {
                            avisoErro("Não foi possível remover a normativa.");
                        }
                    })
                    .catch(res => {
                        if (res.response.data) {
                            $this.msgErro = res.response.data.msg + " - " + res.response.data.errors[0];
                            avisoErro(res.response.data.msg + " - " + res.response.data.errors[0]);
                        } else {
                            avisoErro("Não foi possível remover a normativa.");
                        }
                    });
            },

            download(urlArquivo, dsNome) {
                var nmArquivo = "";
                var nomeArquivo = urlArquivo.split('/');
                if (nomeArquivo.length > 0) {
                    nmArquivo = nomeArquivo[nomeArquivo.length - 1];
                    nmArquivo = dsNome + "." + nmArquivo.split(".")[1];
                }

                axios({
                    url: `${urlApi}/Utilidade/BaixarArquivo?urlArquivo=${urlArquivo}&nmArquivo=${nmArquivo}`, //your url
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', nmArquivo); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                });
            },

            setUploadFile(lstFiles) {
                if (lstFiles == null || lstFiles === '') {
                    this.files = [];
                    return;
                }

                const items = Array.isArray(lstFiles) ? lstFiles : [lstFiles];
                if (!Array.isArray(this.files)) {
                    this.files = [];
                }

                items.forEach(item => {
                    if (!item || !item.key) return;
                    if (this.files.some(f => f.key === item.key)) return;
                    this.files.push({
                        hash: item.hash,
                        key: item.key,
                        fileName: item.fileName,
                        nmNorma: '',
                        dsNorma: '',
                    });
                });
            },

            deleteUploadFile(hash) {
                this.files = (this.files || []).filter(function (obj) { return obj.hash !== hash });
            },
        },
        created: function () {
            this.load();
        },
        mounted: function () {
            this.$store.commit('setNormativas');
        },
        watch: {
            showModal: function () {
                this.myModalAlternative = new window.bootstrap.Modal('#ModalNormativa');
                this.myModalAlternative.show();

                this.usuario = {
                    senhaAtual: null,
                    dsSenha: null,
                    dsSenhaConfirma: null,
                };
                this.files = [];
                this.reset = !this.reset;
            },
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="css" scoped>
    /* MODAL ModalNormativa */
    .form-control {
        border: 1px solid #474747;
    }

    input[type="file"] {
        display: none;
    }

    .custom-file-upload {
        display: inline-block;
        padding: 6px 25px;
        cursor: pointer;
        background: linear-gradient(90deg, rgba(0, 81, 173, 1) 0%, rgba(0, 191, 81, 1) 100%);
        font-weight: 500;
        font-size: 16px;
        line-height: 26px;
        color: #FFF;
    }

    .box-files {
        display: flex;
        .item-files
        {
            display: inline-block;
            padding: 5px;
            border: 1px solid #ccc;
            border-radius: 5px;
        }
    }
    a {
        color: var(--bs-body-color);
    }

    .norma-arquivos {
        margin-top: 1.25rem;
    }

    .norma-arquivo {
        margin-bottom: 1rem;
        padding: 0.9rem 1rem;
        border: 1px solid #d7dee8;
        border-radius: 8px;
    }

    .norma-arquivo-titulo {
        margin-bottom: 0.75rem;
        font-weight: 600;
        word-break: break-word;
    }
</style>

